export default __webpack_public_path__ + "static/media/teacher.6e984623.svg";